<template>
  <aside class="main-sidebar sidebar-color elevation-4">
    <div class="sidebar main-sidebar">
      <router-link
        :to="{ name: 'Dashboard' }"
        class="brand-link border-0 w-100 text-center"
      >
        <img
          src="@/assets/image/logo-artrade2.png"
          alt="Artrade Logo"
          style="width: 150px"
        />
      </router-link>
      <nav class="mt-2">
        <ul
          class="nav nav-pills nav-sidebar flex-column"
          style="position: none"
          data-widget="treeview"
          role="menu"
          data-accordion="true"
        >
          <li class="nav-item">
            <router-link
              :to="{ name: 'Dashboard' }"
              class="nav-link"
              active-class="route-is-active"
              exact
            >
              <i class="nav-icon fas fa-th-large"></i>
              <p>Dashboard</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'Profile' }"
              class="nav-link"
              active-class="route-is-active"
              
            >
              <i class="nav-icon fas fa-user"></i>
              <p>Profile</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'RobotList' }"
              class="nav-link"
              active-class="route-is-active"
              
            >
              <i class="nav-icon fas fa-robot"></i>
              <p>Robot</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'Order' }"
              class="nav-link"
              active-class="route-is-active"
              
            >
              <i class="nav-icon fas fa-clipboard-list"></i>
              <p>Order</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'Subscription' }"
              class="nav-link"
              active-class="route-is-active"
              
            >
              <i class="nav-icon fas fa-tag"></i>
              <p>Subscription</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'Disbursement' }"
              class="nav-link"
              active-class="route-is-active"
              
            >
              <i class="nav-icon fas fa-coins"></i>
              <p>Disbursement</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'Bonus' }"
              class="nav-link"
              active-class="route-is-active"
              
            >
              <i class="nav-icon fas fa-hand-holding-usd"></i>
              <p>Bonus Vendor</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'Bank' }"
              class="nav-link"
              active-class="route-is-active"
              
            >
              <i class="nav-icon fas fa-university"></i>
              <p>Bank Account</p>
            </router-link>
          </li>
          <li class="nav-item" @click="logout()">
            <router-link to="#" class="nav-link">
              <i class="nav-icon fas fa-sign-out-alt"></i>
              <p>Log Out</p>
            </router-link>
          </li>
        </ul>
        
      </nav>
    </div>
  </aside>
</template>

<script>
import swal from 'sweetalert'
export default {
  name: "SideBar",
  methods: {
    logout() {
      swal("Are you sure to logout?", '', "info",  {
         buttons: ["Cancel", "Yes"],
      }).then((res)=>{
        if(res){
          const body = document.querySelector('body')
          if (window.innerWidth <= 989 ) {
            body.classList.remove('sidebar-open')
            body.classList.add('sidebar-closed')
            body.classList.add('sidebar-collapse')
          }
          this.$store.dispatch("logout");
        }
      })
      
    },
  },
};
</script>

<style scoped>
.nav-item {
  font-size: 19px;
  padding: 0.5rem 0;
}
.nav-item i {
  font-size: 1.25rem;
}
.sidebar-color {
  background: #000!important;
}
.nav-link {
  color: #fff !important;
}
.nav-link:hover {
  color: #FFFFFF!important;
  background-color: #2f303a!important;
}
</style>